import type { StateCreator } from "zustand";

/**
 * 위반사항 표시 토글 상태 관리
 * - showManpowerViolations: 최소인원 위반사항 표시 여부
 * - showConfigViolations: 설정 위반사항 표시 여부
 * - showWantedViolations: 원티드 반영사항 표시 여부
 */

export interface ViolationVisibilitySlice {
  showManpowerViolations: boolean; // 최소인원 위반사항
  showConfigViolations: boolean; // 설정 위반사항
  showWantedViolations: boolean; // 원티드 반영사항
  toggleManpowerViolations: () => void;
  toggleConfigViolations: () => void;
  toggleWantedViolations: () => void;
}

const initialState = {
  showManpowerViolations: true, // 초기값: 켜져있음
  showConfigViolations: true, // 초기값: 켜져있음
  showWantedViolations: false, // 초기값: 꺼져있음
};

export const createViolationVisibilitySlice: StateCreator<
  ViolationVisibilitySlice
> = (set) => ({
  ...initialState,
  toggleManpowerViolations: () =>
    set((state) => {
      const newManpowerState = !state.showManpowerViolations;
      // 최소인원 위반사항 보기를 켜면 원티드 반영사항 보기를 자동으로 끔
      if (newManpowerState) {
        return {
          showManpowerViolations: true,
          showWantedViolations: false,
        };
      }
      return {
        showManpowerViolations: false,
      };
    }),
  toggleConfigViolations: () =>
    set((state) => {
      const newConfigState = !state.showConfigViolations;
      // 설정 위반사항 보기를 켜면 원티드 반영사항 보기를 자동으로 끔
      if (newConfigState) {
        return {
          showConfigViolations: true,
          showWantedViolations: false,
        };
      }
      return {
        showConfigViolations: false,
      };
    }),
  toggleWantedViolations: () =>
    set((state) => {
      const newWantedState = !state.showWantedViolations;
      // 원티드 반영사항 보기를 켜면 최소인원, 설정 위반사항 보기를 자동으로 끔
      // (연속 에러 UI와 opacity 충돌 방지)
      if (newWantedState) {
        return {
          showWantedViolations: true,
          showManpowerViolations: false,
          showConfigViolations: false,
        };
      }
      return {
        showWantedViolations: false,
      };
    }),
});
